export default "__VITE_ASSET__DsXab87h__"